export const constants = {
  appVersionCode: 127,
  cache: {
    expireThreshold: 3 * 60 * 1000, // 3 minutes
    uniqueLabels: ['favorites', 'shopping-cart'], // Entries on cache with these labels will be unique
    whiteListLabels: ['favorites', 'highlights', 'opportunities', 'shopping-cart'], // Entries on cache with these labels will be saved on localStorage
  },
  consumerCreditDiscountBenefit: {
    requestedCreditDateSubtraction: 90, // days
    threshold: 0.7,
  },
  defaultCurrency: 'MXN',
  defaultLocale: 'es-MX',
  maxFavoriteItems: 16,
  maxShoppingCartItems: 16,
  maxTrackedProduct: 16,
  mortgageSimulator: {
    loanPercentage: {
      maximum: 0.9,
      minimum: 0.1,
    },
    propertyValue: {
      maximum: 999999999,
      minimum: 250000,
    },
  },
  paymentOptions: ['debit', 'credit', 'credit-3', 'credit-6', 'credit-12', 'credit-18', 'credit-24', 'credit-36'] as const,
  postalCodeLength: 5, // TODO F&F: remove or add/define all the country specific validations here
  pricing: {
    ecommerce: {
      sale: 0.35,
      superSale: 0.5,
    },
  },
  remodeling: {
    types: [
      { label: 'Integral', value: 'fullhouse' },
      { label: 'Cocina', value: 'kitchen' },
      { label: 'Baño', value: 'bathroom' },
      { label: 'Otra', value: 'others' },
    ],
  },
  shipping: {
    priority: {
      delay: 2,
      time: 5,
    },
    regular: {
      delay: 5,
      time: 10,
    },
  },
  tax: 0.16,
  warehouse: {
    aboutToExpireThreshold: 7, // days
  },
};
